import i18n from 'services/base/i18n';

export default {
  // Label for the name of this pangolin
  pangolinName: () => i18n.pgettext('Pages|Unlink Pangolin', 'PANGOLIN NAME'),
  // Label for the timezone setting of this pangolin
  deviceTimezone: () => i18n.pgettext('Pages|Unlink Pangolin', 'DEVICE TIMEZONE'),
  // Label that tells the user what version of our software is running on the Pangolin
  firmwareVersion: () => i18n.pgettext('Pages|Unlink Pangolin', 'FIRMWARE VERSION'),
  // When the user reboots the pangolin, this gets displayed
  rebootSucceeded: () => i18n.pgettext('Pages|Unlink Pangolin', 'The Pangolin was successfully rebooted.'),
  // If the pangolin fails to reboot for any reason, this gets displayed
  rebootError: () => i18n.pgettext('Pages|Unlink Pangolin', 'Reboot failed. Please try again later.'),
  // Button to reboot the pangolin
  rebootPangolin: () => i18n.pgettext('Pages|Unlink Pangolin', 'Reboot Pangolin'),
  // Button to unlink the pangolin from this account (so that it may be linked to a new account later)
  unlinkPangolin: () => i18n.pgettext('Pages|Unlink Pangolin', 'Unlink Pangolin'),
  // Instructions to enter the user's password (required to unlink a pangolin)
  password: () => i18n.pgettext('Pages|Unlink Pangolin', 'ENTER PASSWORD'),
  // A popup asking if the user is sure appears when they try to unlink the pangolin
  modalTitle: () => i18n.pgettext('Pages|Unlink Pangolin', 'ARE YOU SURE?'),
  // Some more text as part of the warning popup
  unlinkWarning: () => i18n.pgettext('Pages|Unlink Pangolin', 'Warning: This will erase all of your data and settings in your Pangolin. This CANNOT be undone.'),
};
